import React from 'react';
import urlJoin from 'url-join';
import autobind from 'autobind-decorator';
import FrameMessages from '../const/FrameMessages';
import {getAdHostingWindow} from './utils';
import settings from '../../config/settings';

/**
 * [soon deprecated] Iframe Ads usin old AdTemplate configuration
 */
export default class IframeModalAd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.isCloseAdSetUp = false;
  }

  componentDidMount() {
    this.setupCloseAdInterval = setInterval(this.checkCanSetupCloseAd, 500);
  }

  @autobind
  checkCanSetupCloseAd() {
    if (this.props.hasAmazonContentLoaded()) {
      this.setupCloseAd();
    }
  }

  componentWillUnmount() {
    this.closeAdCountdownInterval && clearInterval(this.closeAdCountdownInterval);
    this.closeAdCountdownInterval = false;
  }

  render() {
    return this.renderCloseAd();
  }

  renderCloseAd() {
    return (
      <a className="vupClosePopup"
         onClick={this.handleClosePopup}>
        <img
          className="vupClosePopup__icon"
          src={urlJoin(settings.frontendBaseURL, '/static/icons/ad_close_with_label.svg')}
          alt="Close Ad"
        />
      </a>
    );
  }

  @autobind
  handleClosePopup() {
    const {frameId} = this.props;
    getAdHostingWindow().postMessage({title: FrameMessages.requestHide, frameId}, '*');
  }

  @autobind
  setupCloseAd() {
    const {closeTimeoutDuration} = this.props;
    if (this.isCloseAdSetUp) {
      return;
    }
    this.isCloseAdSetUp = true;
    clearInterval(this.setupCloseAdInterval);

    if (!closeTimeoutDuration) {
      this.setState({
        canCloseAd: true
      });
      return;
    }

    if (closeTimeoutDuration > 0) {
      this.setState({
        closeAdCountdown: closeTimeoutDuration,
        canCloseAd: false
      });

      setTimeout(this.handleCloseTimeoutElapsed, closeTimeoutDuration * 1000);
      this.closeAdCountdownInterval = setInterval(this.updateCloseAdCountdown, 1000);
    }
  }

  @autobind
  handleCloseTimeoutElapsed() {
    this.setState({canCloseAd: true});
    getAdHostingWindow().postMessage({title: FrameMessages.allowDismiss, frameId: this.props.frameId}, '*');
  }

  @autobind
  updateCloseAdCountdown() {
    let {closeAdCountdown} = this.state;
    closeAdCountdown -= 1;
    this.setState({closeAdCountdown});
    if (closeAdCountdown <= 0) {
      this.closeAdCountdownInterval && clearInterval(this.closeAdCountdownInterval);
    }
  }
}
